import type { MeasurementName, VitalMeasurement } from '@quromedical/models';

export type Measurement = Pick<VitalMeasurement, 'ts' | 'value' | 'type'>;

export type Vitals = Partial<Record<MeasurementName, Measurement>>;

export type Resolver<TParams> = (
  relative: number,
  windowVitals: Vitals,
  params: TParams,
) => Measurement[];

export type Configuration<TParams> = {
  window?: number;
  /**
   * Find measures that pair with the desired metric
   * The resolver will be run for each of these as they are found
   */
  base: MeasurementName;
  resolve: Resolver<TParams>;
};

export type Calculate<TParams> = (
  input: Measurement[],
  params: TParams,
) => Measurement[];

export type Interpret<TParams> = (
  configs: Configuration<TParams>[],
) => Calculate<TParams>;

export type Compose<TParams> = (
  resolvers: Calculate<TParams>[],
) => Calculate<TParams>;

export const getValue = (measurement?: Measurement): number | undefined => {
  if (!measurement) {
    return undefined;
  }

  const result = parseFloat(measurement.value);
  const isInvalid = isNaN(result);

  if (isInvalid) {
    return undefined;
  }

  return result;
};
